module.exports = __webpack_public_path__ + "media/images/bg/shapes/hexagon-8fc2fbb9b821b35339e41a4b4180f446.svg";